import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import React, { createContext, useState } from "react";
import SectionsHeading from "../../MainComponent/SectionsHeading";
import SupplyTable from "../Table";
import AmountSelectPage from "./PaymentSelectPage";

const GridWrapper = styled(Grid)`
  display: flex;
  width: 100%;
  height: auto;
  column-gap: 20px;
  row-gap: 20px;
`;
const CardGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 100%;
  background: linear-gradient(to top, #161616e0, #161616);
  padding: 20px;
  border-radius: 20px;
  min-height: ${(props) => (props.mh ? props.mh : "30vh")};
  z-index: 1;
`;
const RowDiv = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const PageContext = createContext()
const SupplyHome = () => {
    const [pageState , setPageState] = useState("home")
  return (
<PageContext.Provider value={{pageState, setPageState}}>
    {
        pageState === "home" ? (
            <GridWrapper container>
            <CardGrid  item xs={12}>
              <RowDiv>
              <SectionsHeading fm="PoppinsSB" fs="16px" ta="center" color="#FC9D00">
              Supply
              </SectionsHeading>
              {/* <Notification>
              <Paragraph fs="10px" p="0" ta="left" color="#1AC1FF">
              Your Ethereum wallet is empty.Purchase or transfer assets.
              </Paragraph>
              </Notification> */}
              </RowDiv>
              <SupplyTable/>
            </CardGrid>
            {/* ///////////////////////////////////////// */}
          </GridWrapper>
        ) : pageState === "1st" ?
        (
            <AmountSelectPage/>
        ) : ("")
    }
    
    </PageContext.Provider>
  );
};

export default SupplyHome;
